// extracted by mini-css-extract-plugin
export default {"scope":"_80fmY","thead":"BJ1AR","tbody":"jIv1T","tr":"kwx1k","tr--is-selected":"lXAxl","th":"btX6v","td":"_8X62n OFoip","no-records":"TZYid"};